import { render, staticRenderFns } from "./UcMeterReadings.yaml?vue&type=template&id=3a112b05&component"
import script from "./UcMeterReadings.yaml?vue&type=script&lang=ts&component"
export * from "./UcMeterReadings.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports